import * as React from 'react';
import { ComplexValue } from 'app/types-shared';
import { ComponentProps, LabelConfig } from 'ui';
import styles from './detail-form-panel-header.scss';

export interface DetailFormPanelHeaderProps extends ComponentProps{
  label: LabelConfig;
  expandAll?: boolean;
  primaryKey?: ComplexValue<number>;
  children?: any;
}

export const DetailFormPanelHeader = (props: DetailFormPanelHeaderProps) => {
  const {expandAll, label, primaryKey, children, componentId} = props;
  
  return (expandAll && 
    <div id={componentId} className={`${styles.detailFormPanelHeader}`}>
      <h3> {label?.text} {' #'} {primaryKey?.value} </h3>
      {children?.map((child, index) => (<span key={index}>{child} </span>))}
    </div>);
};
